import type { ApolloError } from '@apollo/client';
import { $ } from '../lib/generated/zeus';
import { useTypedMutation } from '../lib/generated/zeus/apollo';
import { eventData } from '../lib/graphql/common/queries';

/**
 * Provides GraphQL mutation to update a Team Role.
 * @returns custom hook that provides GraphQL mutation to update a Team Role.
 */
const useUpdateTeamRole = (onError: (e: ApolloError) => void) => {
  const mutation = useTypedMutation(
    {
      insert_event_team_role_updated_one: [
        {
          object: {
            name: $('name', 'String!'),
            role_group: $('roleGroup', 'role_group_t'),
            team_role_id: $('teamRoleId', 'uuid!'),
            event: eventData('team_role_updated'),
          },
        },
        {
          id: true,
        },
      ],
    },
    {
      apolloOptions: {
        onError,
      },
    }
  );

  return mutation;
};

export default useUpdateTeamRole;
